import { call, put, takeEvery, select } from 'redux-saga/effects';
// Constants
import { ADMIN } from '../../Actions/Admin/types';
import {
  verifyEmailAddressSuccess,
  getUserDetailsFailure,
  getUserDetailsSuccess,
  updateUserSuccess,
  addUserSuccess,
  progressbufferOn,
  getLanguageDetailsSuccess,
  getLanguageDetailsFailure,
  fetchRegexSuccess,
  fetchRegexFailure,
} from '../../Actions/Admin/adminActions';
import {
  validateEmailAddress,
  addUserApi,
  updateUserApi,
  getUserDetailsApi,
  getLanguageDetailsApi,
  getEmailRegexApi,
} from '../../Services/Admin/adminServices';
import {
  getCustomerUsers,
  getCustomerUsersSuccess,
} from 'src/Actions/Customers/customerAction';
import { getSubscriptionInfo } from 'src/Actions/Subscription/subscriptionAction';
import i18n from 'src/i18n';

// Saga handlers
export default function* adminSaga() {
  yield takeEvery(ADMIN.VERIFY_EMAIL, handleValidateUser);
  yield takeEvery(ADMIN.ADD_USER, handleAddUser);
  yield takeEvery(ADMIN.ADD_TEAM_MEMBER, handleAddTeamMember);
  yield takeEvery(ADMIN.UPDATE_USER, handleUpdateUser);
  yield takeEvery(ADMIN.GET_USER_DETAILS, fetchUserDetails);
  yield takeEvery(ADMIN.GET_LANGUAGE_DETAILS, fetchlanguageDetails);
  yield takeEvery(ADMIN.FETCH_REGEX_REQUEST, fetchRegexDetails);
}

const getSubscription = (state) => state.subscription;

export function* handleValidateUser(data) {
  let { activationKey, persona, email } = data;
  try {
    let response = yield call(
      validateEmailAddress,
      activationKey,
      persona,
      email
    );
    if (response && response.status === 200 && response.data) {
      yield put(verifyEmailAddressSuccess(response.data));
    }
  } catch (e) {}
}

export function* handleAddUser(data) {
  let { userRequest, isEdit } = data;
  let { subscriptionInfo } = yield select(getSubscription);
  let payload = {
    activationKey: userRequest.activationKey,
    searchKey: '',
  };
  try {
    let response = yield call(addUserApi, userRequest);
    if (response && (response.status === 200 || response.status === 204)) {
      let message = isEdit ? i18n.t('accUpdated') : i18n.t('accAdded');
      if (isEdit && userRequest.emailId === subscriptionInfo.email) {
        yield put(getSubscriptionInfo());
      }
      yield put(addUserSuccess(message));
      yield put(getCustomerUsers(payload));
    }
  } catch (e) {}
}

export function* handleAddTeamMember(data) {
  let { userRequest, isEdit } = data;
  let { subscriptionInfo } = yield select(getSubscription);
  try {
    let response = yield call(addUserApi, userRequest);
   
    if (response && (response.status === 200 || response.status === 204)) {
      let message = isEdit ? i18n.t('accUpdated') : i18n.t('accAdded');
      if (isEdit && userRequest.emailId === subscriptionInfo.email) {
        yield put(getSubscriptionInfo());
      }
      yield put(progressbufferOn(message));
    }
  } catch (e) {}
}

export function* handleUpdateUser(data) {
  let { activationKey, isValid, email, searchKey } = data;
  let payload = {
    activationKey: activationKey,
    searchKey: searchKey,
  };
  let req = {
    activationKey: activationKey,
    isValidUser: isValid,
    reqEmail: email,
  };
  try {
    let response = yield call(updateUserApi, req);
    if (response && (response.status === 200 || response.status === 204)) {
      yield put(getCustomerUsersSuccess({}));
      yield put(updateUserSuccess(i18n.t('accUpdated')));
      yield put(getCustomerUsers(payload));
    }
  } catch (e) {}
}

export function* fetchUserDetails(data) {
  let { emailId, activationKey } = data;
  try {
    let response = yield call(getUserDetailsApi, emailId, activationKey);
    if (response && response.status === 200 && response.data) {
      yield put(getUserDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getUserDetailsFailure(e));
  }
}

export function* fetchlanguageDetails() {
  try {
    let response = yield call(getLanguageDetailsApi);
    if (response && response.status === 200 && response.data) {
      yield put(getLanguageDetailsSuccess(response.data));
    }
  } catch (e) {
    yield put(getLanguageDetailsFailure(e));
  }
}

export function* fetchRegexDetails() {
  try {
    let response = yield call(getEmailRegexApi);
    if (response && response.status === 200 && response.data) {
      yield put(fetchRegexSuccess(response.data.configValue));
    }
  } catch (e) {
    yield put(fetchRegexFailure(e));
  }
}
